export default __webpack_public_path__ + "reaktor.a6dbb583.png";